module.exports = __webpack_public_path__ + "img/pro.cc5a79fa.svg";